import { Text } from "components/base/Form";
import { useContext, useState } from "react";
import { GTMProjectContext } from "./GTMProjectContext";

const NotesView = () => {
  const { originalGTMProject, autoSave } = useContext(GTMProjectContext);
  const [projectNotes, setProjectNotes] = useState(
    originalGTMProject.projectNotes,
  );

  function onChangeNotes(newNotes) {
    setProjectNotes(newNotes);
    autoSave({ id: originalGTMProject.id, projectNotes: newNotes });
  }

  return (
    <div className="card">
      <h5>Notes</h5>
      <div className="-mx-1 mt-2">
        <Text
          placeholder="Write your notes for this project here."
          value={projectNotes}
          onChange={(e) => onChangeNotes(e.target.value)}
        />
      </div>
    </div>
  );
};

export default NotesView;
